// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jn-0";